<div class="confirm-container">
  <span mat-dialog-title>Add Past Date</span>
  <div mat-dialog-content>
    <form>
      <div class="row">
        <mat-form-field>
          <mat-select [(value)]="selectedStatus" [compareWith]="compareStatuses">
            @for (status of (ddService.statuses$ | async); track status) {
              <mat-option [value]="status">{{status.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field>
          <input
            matInput
            [matDatepicker]="picker"
            [value]="selectedDate"
            (dateChange)="onDateChange($event)"
            />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div mat-dialog-actions style="float:right;margin:20px;">
    <button mat-button (click)="save()">SAVE</button>
    <button mat-button (click)="close()">
      Cancel
    </button>
  </div>
</div>
